if(!customElements.get('add-ons-component')) {
    customElements.define(
      'add-ons-component',
      class AddOnsComponent extends HTMLElement {
        constructor() {
          super();
          this.mainProductId = this.dataset.main_product_id;
          this.addonType = this.dataset.addons_type;
          this.enableImageSwitching = this.dataset.enable_image_switching === 'true';
          this.addonTypeText = this.dataset.addon_type_text;
          this.ADD_TO_CART_TEXT = `ADD ${this.addonTypeText.toLocaleUpperCase()} TO BASKET`;
          
          this.isLoading = false;
        }
      
        getSectionId() {
          const mediaItem = document.querySelector('.product [data-media-id]');
          if (mediaItem) {
            const mediaId = mediaItem.getAttribute('data-media-id');
            const parts = mediaId.split('-');
            if (parts.length > 1 && /^\d+$/.test(parts[parts.length - 1])) {
              parts.pop();
              return parts.join('-');
            }
          }
          return 'product-gallery';
        }
      
        getZoomIconSVG() {
          return '<svg aria-hidden="true" focusable="false" class="icon icon-zoom" fill="none" viewBox="0 0 18 18"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.03 11.68A5.784 5.784 0 112.85 3.5a5.784 5.784 0 018.18 8.18zm.26 1.12a6.78 6.78 0 11.72-.7l5.4 5.4a.5.5 0 11-.71.7l-5.41-5.4z" fill="currentColor"/></svg>';
        }
      
        getModalId() {
          const existingModalOpener = document.querySelector('modal-opener[data-modal]');
          if (existingModalOpener) {
            const modalAttr = existingModalOpener.getAttribute('data-modal');
            return modalAttr.replace('#', '');
          }
          return `ProductModal-${this.getSectionId()}`;
        }
      
        connectedCallback() {
          if (!this.mainProductId || !this.addonType) {
            console.error('Add-ons component missing required data attributes');
            return;
          }
          
          this.sharedServices = window.AddonSharedServices;
          this.cache = this.sharedServices?.cache;
          this.sharedCart = this.sharedServices?.sharedCart;
          
          if (!this.sharedServices) {
            console.error('AddonSharedServices not available.');
            return;
          }
          
            this.setupEventListeners();
          this.restoreStateFromCache();
          this.syncWithCartOnLoad();
        }
      
        disconnectedCallback() {
        }
      
        setupEventListeners() {
          this.querySelectorAll('.add-ons-items__checkbox').forEach(checkbox => {
            checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
          });
          
          const button = this.querySelector('.add-ons-item__cart-button');
          if (button) {
            button.addEventListener('click', this.handleAddonButtonClick.bind(this));
          }
          if (typeof subscribe === 'function') {
          subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
              if (event.source === 'addon-system') return;
              if (event.hasOwnProperty('variant_id') || event.hasOwnProperty('variantId')) return;
              
              // Only clear cache for cart-items events
              if (event.source === 'cart-items') {
                this.sharedCart.clearCache();
              }
              
              this.syncWithCart().then(() => {
                this.restoreStateFromCache();
              });
            });
          }
          
          document.addEventListener('addon:set-added', (event) => {
            if (event.detail.mainProductIds.includes(this.mainProductId)) {
              this.restoreStateFromCache();
            }
          });
        }
      
        handleCheckboxChange(event) {
          const checkbox = event.target;
          const isChecked = checkbox.checked;
          
          if (isChecked) {
            this.uncheckOtherCheckboxes(checkbox);
            if (this.enableImageSwitching) {
              this.hideAddonImages();
              this.showAddonImages(checkbox);
            }
          } else {
            if (this.enableImageSwitching) {
              this.hideAddonImages();
            }
          }
      
          this.updateAddonButtonStateForSelection();
          this.updatePriceAndTotals();
          this.updateDeliveryDate();
        }
        
        async handleAddonButtonClick(event) {
          event.preventDefault();
          if (this.isLoading) return;
          
          this.setButtonLoading(this.querySelector('.add-ons-item__cart-button'), true);
          this.setCheckboxesEnabled(false);
          
          this.hideNotification();
          
          try {
            const checkedCheckbox = this.querySelector('.add-ons-items__checkbox:checked');
            const cache = this.cache.getCache(this.mainProductId);
            const currentAddon = cache.addons?.[this.addonType];
            
            const { cart, addonItems } = await this.syncWithCart();
            const currentCartItem = addonItems.find(item => 
              item.variant_id.toString() === currentAddon?.variantId
            );
            
            if (currentAddon && checkedCheckbox) {
              const variantId = checkedCheckbox.dataset.product_id;
              
              if (currentAddon.variantId !== variantId) {
                await this.updateAddon(currentAddon.variantId, variantId, currentCartItem?.key);
                this.showNotification('1 item added, 1 item removed', 'updated');
              }
            } else if (currentAddon && !checkedCheckbox) {
              await this.removeAddon(currentCartItem?.key);
              this.showNotification('1 item removed', 'removed');
            } else if (checkedCheckbox) {
              const variantId = checkedCheckbox.dataset.product_id;
              await this.addAddon(variantId);
              this.showNotification('1 item added', 'added');
            }
            this.updatePriceAndTotals();
            this.updateDeliveryDate();
            
          } catch (error) {
            console.error('Addon operation failed');
            this.restoreStateFromCache();
          } finally {
            this.setButtonLoading(this.querySelector('.add-ons-item__cart-button'), false);
            this.setCheckboxesEnabled(true);
          }
        }
        
        async addAddon(variantId) {
          const uniqueId = this.cache.updateAddon(this.mainProductId, this.addonType, variantId);
          
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: variantId,
                quantity: 1,
                properties: {
                  addon_unique_id: uniqueId
                }
              }]
            })
          });
      
          if (!response.ok) {
            this.cache.removeAddon(this.mainProductId, this.addonType);
            throw new Error(`Failed to add addon: ${response.status}`);
          }
      
          const result = await response.json();
          if (result.status) {
            throw new Error(result.description || 'Failed to add add-on to cart');
          }
      
          this.sharedCart.clearCache();
          document.dispatchEvent(new CustomEvent('addon:added', { 
            detail: { mainProductId: this.mainProductId, addonType: this.addonType, variantId, uniqueId }
          }));
          
          this.refreshCartDrawer();
          return result;
        }
      
        async updateAddon(oldVariantId, newVariantId, cartKey) {
          try {
            await this.removeAddon(cartKey);
            await this.addAddon(newVariantId);
            document.dispatchEvent(new CustomEvent('addon:updated', { 
              detail: { mainProductId: this.mainProductId, addonType: this.addonType, oldVariantId, newVariantId }
            }));
          } catch (error) {
            console.error('Failed to update addon');
            this.restoreStateFromCache(); // Restore UI to match actual cart state
            throw error; 
          }
        }
        
        async removeAddon(cartKey) {
          const response = await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
              id: cartKey,
                quantity: 0
              })
            });
      
          if (!response.ok) {
            throw new Error(`Failed to remove add-on: ${response.status}`);
          }
          
          const updatedCart = await response.json();
          
          this.cache.removeAddon(this.mainProductId, this.addonType);
          this.sharedCart.clearCache();
          document.dispatchEvent(new CustomEvent('addon:removed', { 
            detail: { mainProductId: this.mainProductId, addonType: this.addonType }
          }));
          
          this.refreshCartDrawer();
          return updatedCart;
        }
        
        async syncWithCart() {
          const cart = await this.sharedCart.getCart();
          const cache = this.cache.getCache(this.mainProductId);
          if (!cache.uniqueId) return { cart, addonItems: [] };
          
          const addonItems = cart.items.filter(item => 
            item.properties?.addon_unique_id === cache.uniqueId
          );
          
          this.cache.syncWithCart(this.mainProductId, addonItems);
          return { cart, addonItems };
        }
        
        async syncWithCartOnLoad() {
          try {
            await this.syncWithCart();
            this.restoreStateFromCache();
          } catch (error) {
            console.error('Failed to sync with cart on load');
          }
        }
        
        restoreStateFromCache() {
          const cache = this.cache.getCache(this.mainProductId);
          const currentAddon = cache.addons?.[this.addonType];
          
          this.querySelectorAll('.add-ons-items__checkbox').forEach(cb => cb.checked = false);
          
          if (currentAddon) {
            const checkbox = this.querySelector(`[data-product_id="${currentAddon.variantId}"]`);
            if (checkbox) {
              checkbox.checked = true;
              
              if (this.enableImageSwitching) {
                this.showAddonImages(checkbox);
              }
            }
          } else {
            if (this.enableImageSwitching) {
              this.hideAddonImages();
            }
          }
      
          requestAnimationFrame(() => {
            if (!this.isLoading) {
              this.updateAddonButtonStateForSelection();
            }
            this.updatePriceAndTotals();
            this.updateDeliveryDate();
          });
        }
      
        updateAddonButtonStateForSelection() {
          const button = this.querySelector('.add-ons-item__cart-button');
          if (!button) return;
      
          if (this.isLoading) return;
          
          const buttonText = button.querySelector('span');
          if (!buttonText) return;
      
          const checkedCheckbox = this.querySelector('.add-ons-items__checkbox:checked');
          const cache = this.cache.getCache(this.mainProductId);
          const currentAddon = cache.addons?.[this.addonType];
          
          if (currentAddon) {
            buttonText.textContent = 'UPDATE ITEM IN CART';
            button.disabled = !this.hasSelectionChanged();
          } else if (checkedCheckbox) {
            buttonText.textContent = this.ADD_TO_CART_TEXT;
            button.disabled = false;
          } else {
            buttonText.textContent = this.ADD_TO_CART_TEXT;
            button.disabled = true;
          }
        }
        
        hasSelectionChanged() {
          const checkedCheckbox = this.querySelector('.add-ons-items__checkbox:checked');
          const cache = this.cache.getCache(this.mainProductId);
          const currentAddon = cache.addons?.[this.addonType];
          
          const selectedVariantId = checkedCheckbox?.dataset.product_id?.toString();
          const currentVariantId = currentAddon?.variantId?.toString();
          
          if (!currentAddon && selectedVariantId) return true;
          if (currentAddon && !selectedVariantId) return true;
          if (currentAddon && selectedVariantId && currentVariantId !== selectedVariantId) return true;
          return false;
        }
        
        uncheckOtherCheckboxes(currentCheckbox) {
          const checkboxes = this.querySelectorAll('.add-ons-items__checkbox');
          checkboxes.forEach(checkbox => {
            if (checkbox !== currentCheckbox) {
              checkbox.checked = false;
            }
          });
        }
        
        refreshCartDrawer() {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.refresh(false, 'addon-system');
          }
        }
        
        setCheckboxesEnabled(enabled) {
          const checkboxes = this.querySelectorAll('.add-ons-items__checkbox');
          checkboxes.forEach(checkbox => {
            checkbox.disabled = !enabled;
          });
        }
        
        setButtonLoading(button, loading) {
          if (!button) return;
      
          const spinner = button.querySelector('.loading__spinner');
          
          if (loading) {
            this.isLoading = true;
            button.disabled = true;
            if (spinner) {
              spinner.classList.remove('hidden');
            }
          } else {
            this.isLoading = false;
            if (spinner) {
              spinner.classList.add('hidden');
            }
            this.updateAddonButtonStateForSelection();
          }
        }
        
        showNotification(message, type = 'added-to-cart') {
          //scroll to top of the addons items when showing notification
          const addonsItemsContainer = this.querySelector('.add-ons-items');
          if (addonsItemsContainer) {
            addonsItemsContainer.scrollTo({
              top: 0,
              behavior: 'smooth' // optional
            });
          }

          const notification = this.querySelector('.add-ons-items__notification');
          const notificationContent = this.querySelector('.add-ons-items__notification-content');
          const notificationText = notificationContent?.querySelector('p');
          
          if (!notification || !notificationContent || !notificationText) return;
          
          // Set notification text
          notificationText.textContent = message;
          
          // Show notification with fade in
          notification.style.opacity = '1';

          // Hide notification after 2 seconds
          setTimeout(() => {
            notification.style.opacity = '0';
          }, 2100);
        }
        
        hideNotification() {
          const notification = this.querySelector('.add-ons-items__notification');
          if (notification) {
            notification.style.opacity = '0';
          }
        }
      
        updatePriceAndTotals() {
          const checkedCheckbox = this.querySelector('.add-ons-items__checkbox:checked');
          const totalElement = this.querySelector('.add-ons-item__total');
          const totalPriceElement = this.querySelector('.add-ons-item__total-price');
          
          if (checkedCheckbox) {
            const price = parseFloat(checkedCheckbox.dataset.product_price) || 0;
            
            if (totalElement) {
              totalElement.textContent = 'Total (1 Item)';
            }
            
            if (totalPriceElement) {
              const priceValue = (price / 100).toFixed(2);
              const formattedPrice = (typeof formatMoney !== 'undefined') ? 
                formatMoney(priceValue) : 
                priceValue;
              totalPriceElement.textContent = formattedPrice;
            }
          } else {
            if (totalElement) {
              totalElement.textContent = 'Total (0 Items)';
            }
            if (totalPriceElement) {
              const formattedPrice = (typeof formatMoney !== 'undefined') ? 
                formatMoney('0.00') : 
                '0.00';
              totalPriceElement.textContent = formattedPrice;
            }
          }
        }
      
        updateDeliveryDate() {
          const checkedCheckbox = this.querySelector('.add-ons-items__checkbox:checked');
          const deliveryDateElement = this.querySelector('.add-ons-items__footer-delivery-date');
          
          if (!deliveryDateElement) return;
          
          if (checkedCheckbox) {
            const productTags = checkedCheckbox.dataset.product_tags;
            
            if (productTags && window._shipping) {
              try {
                const result = window._shipping.calculateDateRangeForProduct(productTags);
                if (result.success && result.dateRangeString) {
                  const tags = productTags.split(',').map(tag => tag.trim());
                  const hasPreOrderTag = tags.some(tag => tag.includes('meta-pre-order:'));
                  
                  const translationKey = hasPreOrderTag 
                    ? window.shopifyTranslations?.pre_order
                    : window.shopifyTranslations?.in_stock;
                  
                  if (translationKey) {
                    deliveryDateElement.innerHTML = `${translationKey} <strong>${result.dateRangeString}</strong>`;
                    return;
                  }
                }
              } catch (error) {
                console.error('Error calculating delivery date');
              }
            }
          } else {
            deliveryDateElement.innerHTML = '';
          }
        }
      
        showAddonImages(checkbox) {
          if (!this.enableImageSwitching) return;
        
          const productSetImageUrl = checkbox.dataset.product_set_image;
          
          if (!productSetImageUrl || 
              productSetImageUrl === '' || 
              productSetImageUrl === 'null' || 
              productSetImageUrl === 'undefined') {
            this.showOriginalFirstImages();
            this.triggerMediaGallerySync(false);
            return;
          }
        
          const existingImage = document.querySelector(`.product img[src="${productSetImageUrl}"]`);
          
          if (existingImage) {
            this.showExistingProductSetImage(existingImage);
          } else {
            this.injectProductSetImage(productSetImageUrl);
          }
          
          this.hideOriginalFirstImages();
          this.triggerMediaGallerySync(true);
          this.scrollGalleryToTop();
        }
      
        hideAddonImages() {
          if (!this.enableImageSwitching) return;
          
          // Check if there are injected images to remove
          const injectedElements = document.querySelectorAll('[data-addon-injected="true"]');
          const hadInjectedImages = injectedElements.length > 0;
          
          this.removeProductSetImages();
          this.showOriginalFirstImages();
          
          try {
            window.productImages = document.querySelectorAll('.product__media-list .product__media-item');
          } catch (error) {
            console.error('Error updating productImages reference:', error);
          }
          
          this.triggerMediaGallerySync(false);
          
          // Only scroll if images were actually removed
          if (hadInjectedImages) {
            this.scrollGalleryToTop();
          }
        }
      
        injectProductSetImage(imageUrl) {
          const sectionId = this.getSectionId();
          const modalId = this.getModalId();
          const timestamp = Date.now();
          const mediaId = `addon-injected-${timestamp}`;
          
          // Inject into main gallery
          const mainGallery = document.querySelector('.product__media-list');
          if (mainGallery) {
            const li = document.createElement('li');
            li.id = `Slide-${sectionId}-${mediaId}`;
            li.className = 'product__media-item grid__item slider__slide is-active';
            li.setAttribute('data-addon-injected', 'true');
            li.setAttribute('data-media-id', `${sectionId}-${mediaId}`);
            
            const zoomIcon = this.getZoomIconSVG();
            
            li.innerHTML = `
              <div class="product-media-container media-type-image media-fit-cover global-media-settings gradient"
                  style="--ratio: 1.0; --preview-ratio: 1.0;">
                <modal-opener class="product__modal-opener product__modal-opener--image" data-modal="#${modalId}">
                  <div class="loading__spinner hidden">
                    <svg class="spinner" viewBox="0 0 50 50">
                      <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                    </svg>
                  </div>
                  <div class="product__media media media--transparent">
                    <img src="${imageUrl}" 
                        alt="Product with selected addon" 
                        loading="eager"
                        class="image-magnify-hover"
                        onerror="this.closest('.product__media-item').style.display='none'; console.error('Failed to load addon image:', '${imageUrl}');"
                        style="object-fit: cover; object-position: center;" />
                  </div>
                  <button class="product__media-toggle quick-add-hidden"
                          type="button"
                          aria-haspopup="dialog"
                          data-media-id="${mediaId}">
                    <span class="visually-hidden">Open media 1</span>
                  </button>
                </modal-opener>
              </div>
            `;
            
            mainGallery.insertBefore(li, mainGallery.firstChild);
          }
          
          // Inject into modal gallery
          const modalGallery = document.querySelector('.product-media-modal__content');
          if (modalGallery) {
            const div = document.createElement('div');
            div.id = `Slide-${sectionId}-modal-${mediaId}`;
            div.className = 'grid__item slider__slide';
            div.setAttribute('data-addon-injected', 'true');
            div.setAttribute('data-cascade', '');
            div.style.cssText = '--animation-order: 1; height:100vh; display:flex !important;';
            
            div.innerHTML = `
              <img class="scrollBar global-media-settings global-media-settings--no-shadow"
                  src="${imageUrl}"
                  alt="Product with selected addon"
                  loading="eager"
                  width="1100"
                  height="1100"
                  onerror="this.closest('.slider__slide').style.display='none'; console.error('Failed to load addon modal image:', '${imageUrl}');"
                  data-media-id="${mediaId}" />
            `;
            
            modalGallery.insertBefore(div, modalGallery.firstChild);
          }
          
          // Inject into thumbnail gallery
          const thumbnailGallery = document.querySelector('.thumbnail-list');
          if (thumbnailGallery) {
            const li = document.createElement('li');
            const thumbnailId = `Thumbnail-${sectionId}-addon-${timestamp}`;
            
            li.id = `Slide-Thumbnails-${sectionId}-addon-${timestamp}`;
            li.className = 'thumbnail-list__item slider__slide';
            li.setAttribute('data-addon-injected', 'true');
            li.setAttribute('data-target', `${sectionId}-${mediaId}`);
            li.setAttribute('data-media-position', '1');
            
            li.innerHTML = `
              <button class="thumbnail global-media-settings global-media-settings--no-shadow"
                      type="button"
                      aria-label="Load image 1"
                      aria-current="true"
                      aria-controls="GalleryViewer-${sectionId}"
                      aria-describedby="${thumbnailId}">
                <img id="${thumbnailId}"
                    src="${imageUrl}"
                    alt="Product with selected addon"
                    loading="eager"
                    onerror="this.closest('.thumbnail-list__item').style.display='none';" />
              </button>
            `;
            
            thumbnailGallery.insertBefore(li, thumbnailGallery.firstChild);
          }
        }
      
        showExistingProductSetImage(imgElement) {
          const containers = [
            { selector: '.product__media-list', parentSelector: '.product__media-item' },
            { selector: '.product-media-modal__content', parentSelector: '.grid__item.slider__slide' },
            { selector: '.thumbnail-list', parentSelector: '.thumbnail-list__item.slider__slide' }
          ];
        
          containers.forEach(({ selector, parentSelector }) => {
            const container = document.querySelector(selector);
            if (!container) return;
            
            const injectedItems = container.querySelectorAll(`${parentSelector}[data-addon-injected="true"]`);
            
            injectedItems.forEach(item => {
              const itemImg = item.querySelector('img');
              if (itemImg && itemImg.src === imgElement.src) {
                container.insertBefore(item, container.firstChild);
                item.classList.remove('hidden');
                if (selector === '.product-media-modal__content') {
                  item.style.setProperty('display', 'flex', 'important');
                } else {
                  item.style.display = '';
                }
                
                if (selector === '.thumbnail-list') {
                  const button = item.querySelector('button');
                  if (button) {
                    button.setAttribute('aria-current', 'true');
                  }
                }
              }
            });
          });
        }
      
        removeProductSetImages() {
          const injectedElements = document.querySelectorAll('[data-addon-injected="true"]');
          injectedElements.forEach(element => element.remove());
        }
      
        scrollGalleryToTop() {
          const windowWidth = window.innerWidth;
          
          requestAnimationFrame(() => {
            const mainGallery = document.querySelector('.product__media-list');
            
            if (mainGallery) {
              mainGallery.scrollTo({
                top: 0,
                behavior: 'smooth'
              });
            }

            //scroll to top of the page
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          });
        }
      
        hideOriginalFirstImages() {
          const containers = [
            { selector: '.product__media-list', parentSelector: '.product__media-item' },
            { selector: '.product-media-modal__content', parentSelector: '.grid__item.slider__slide' },
            { selector: '.thumbnail-list', parentSelector: '.thumbnail-list__item.slider__slide' }
          ];
        
          containers.forEach(({ selector, parentSelector }) => {
            const container = document.querySelector(selector);
            if (!container) return;
            
            const originalImages = container.querySelectorAll(parentSelector + ':not([data-addon-injected])');
            const firstOriginal = originalImages[0];
            
            if (firstOriginal) {
              firstOriginal.classList.add('hidden');
              if (selector === '.product-media-modal__content') {
                firstOriginal.style.setProperty('display', 'none', 'important');
              } else {
                firstOriginal.style.setProperty('display', 'none', 'important');
              }
              
              if (selector === '.thumbnail-list') {
                const button = firstOriginal.querySelector('button');
                if (button) {
                  button.setAttribute('aria-current', 'false');
                }
              }
            }
          });
        }
      
        showOriginalFirstImages() {
          const containers = [
            { selector: '.product__media-list', parentSelector: '.product__media-item' },
            { selector: '.product-media-modal__content', parentSelector: '.grid__item.slider__slide' },
            { selector: '.thumbnail-list', parentSelector: '.thumbnail-list__item.slider__slide' }
          ];
        
          containers.forEach(({ selector, parentSelector }) => {
            const container = document.querySelector(selector);
            if (!container) return;
            
            const originalImages = container.querySelectorAll(parentSelector + ':not([data-addon-injected])');
            const firstOriginal = originalImages[0];
            
            if (firstOriginal) {
              container.insertBefore(firstOriginal, container.firstChild);
              firstOriginal.classList.remove('hidden');
              if (selector === '.product-media-modal__content') {
                firstOriginal.style.setProperty('display', 'flex', 'important');
              } else {
                firstOriginal.style.setProperty('display', 'block', 'important');
              }
              
              if (selector === '.thumbnail-list') {
                const button = firstOriginal.querySelector('button');
                if (button) {
                  button.setAttribute('aria-current', 'true');
                }
              }
            }
          });
        }
      
        triggerMediaGallerySync(hasMatchingImage = false) {
          const windowWidth = window.innerWidth;
          if(windowWidth > 749) return;

          const mediaGallery = document.querySelector('media-gallery');
          if (!mediaGallery) return;
          
          const firstVisibleImage = document.querySelector('.product__media-item:not(.hidden)');
          if (!firstVisibleImage) return;
          
          const mediaId = firstVisibleImage.dataset.mediaId;
          if (!mediaId) return;
          
          requestAnimationFrame(() => {
            if (typeof mediaGallery.setActiveMedia === 'function') {
              mediaGallery.setActiveMedia(mediaId, false, false);
            }
            
            if (mediaGallery.elements && mediaGallery.elements.viewer) {
              const sliderComponent = mediaGallery.elements.viewer.closest('slider-component-laurajames');
              if (sliderComponent && typeof sliderComponent.resetPages === 'function') {
                sliderComponent.resetPages();
              }
              
            const slideChangedEvent = new CustomEvent('slideChanged', {
              detail: {
                  currentElement: firstVisibleImage
                }
              });
              mediaGallery.elements.viewer.dispatchEvent(slideChangedEvent);
            }
          });
        }
      }
    );
}